var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"table-icon",on:{"click":_vm.switchIconHandler}},[_c('ul',{class:{ table: _vm.isTable, card: !_vm.isTable }},[_c('li',{staticClass:"square"}),_c('li',{ref:"liEl",staticClass:"line"}),_c('li',{staticClass:"square"}),_c('li',{staticClass:"line"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }